export default {
    ACCESS_TOKEN: 'okta-token-storage',
    AREA_UNIT: 'areaUnit',
    DISTANCE_UNIT: 'distanceUnit',
    DISTANCE_UNIT_LABEL: 'distanceUnitLabel',
    HOTEL_CODE: 'hotelCode',
    HOTEL_CURRENCY: 'hotelCurrency',
    HOTEL_INFO: 'hotelInfo',
    HOTEL_INFO_COMPLETED_HISTORY: 'hotelInfoCompletedHistory',
    IS_ADMIN: 'isAdmin',
    IS_HOTEL_DOMESTIC: 'isHotelDomestic',
    IS_READ_ONLY: 'isReadOnly',
    IS_SCANDANAVIAN: 'isScandanavian',
    IS_SUBMITTED: 'isSubmitted',
    LENGTH_UNIT: 'lengthUnit',
    LOCK_OWNER: 'lockOwner',
    MEASUREMENT_SYSTEM: 'measurementSystem',
    ONBOARDING_STATUS: 'onboardingStatus',
    PROPERTY_LIST: 'propertyList',
    REQUESTOR: 'requestor',
    TRACKING_ID: 'trackingId',
    USER: 'user',
    WEIGHT_UNIT: 'weightUnit',
}